import {$util,$array} from "@util/util.js";
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import ViewTool from "../viewTool.js";

export default class GiftView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._extraBoxEl;
    }

    getReduceBtnDisabled(item){
        if(item._count == 1){
            return "disabled";
        }
        return "";
    }

    getMaxBtnDisabled(item){
        let maxCount = this._model.getMaxBuyCount(item);
        // console.log(item,item._count,'++++',maxCount)
        if(item._count >= item._data.maxPurchase){
            return "disabled";
        }
        if(item._count >= this._model._parent._count){
            return "disabled";
        }
        if(item._count>=item._data.stock){
            return "disabled";
        }
        return "";
    }
    getItemTitle(item){
        let maxCount = this._model.getMaxBuyCount(item);
        if(item._data.stock && item._data.maxPurchase){
            if(item._data.maxPurchase < item._data.stock && item._data.maxPurchase < this._model._parent._count){
              return `<p class="le_color_red limit_tip" tag="mainsku_purchaseMsg">限购${item._data.maxPurchase}件</p>`
            }else if(item._data.stock  < this._model._parent._count){
              return `<p class="le_color_red limit_tip" tag="mainsku_purchaseMsg">库存${item._data.stock}件</p>`
            }
          }
          if(item._data.maxPurchase < this._model._parent._count){
            return `<p class="le_color_red limit_tip" tag="mainsku_purchaseMsg">限购${item._data.maxPurchase}件</p>`
          }
          if(item._data.stock  < this._model._parent._count){
            return `<p class="le_color_red limit_tip" tag="mainsku_purchaseMsg">库存${item._data.stock}件</p>`
          }
         
         
          return ''
    }
    getCountBtn(item) {
        // console.log('是否展示选件的加减狂',item)
        //已售罄 or 已下架
        // 在这里分两种情况, 自身失效或者主品失效都不展示加减框
        if(item._invalid || this._model._parent._invalid){
            return `${item._count}`;
        } else {
            //其他
            return `<input type="button" oid='${item._id}' ${this.getReduceBtnDisabled(item)} value="-" class="reduce" tag='optionreduce'>
            <input class="num" oid='${item._id}' tag='optionCount' value="${item._count}" type="text">
            <input type="button" oid='${item._id}' ${this.getMaxBtnDisabled(item)} value="+" class="add" tag='optionadd'>
            ${this.getItemTitle(item)}
            `;
        }
        
    }

    getItems(){
        let html = "";
        this._model._items.forEach((item) => {
            // console.log('%citem===42===: ','color: blue;font-size: 20px;',item._id);

            html += `<div class="clearfix right_item" ids=${item._id}>
                <div class="fl e_goods">
                <span class="fl e_goods_img" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5': '1'}">
                    <img src="${item._img}">
                </span>
                <span class="fl e_goods_desc aaa lenovo-emoji">
                    <p><a target="_blank" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5': '1'}" href="${item._link}">${item._name}</a></p>
                    <span class="le_tip_btn_solid" style="display:${this.getInvalidInfo(item).msg?"block":"none"}">${this.getInvalidInfo(item).msg}</span>
                </span>
                </div>
                <div class="fl le_width_172 e_price" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}""><p class="le_paddingl_65"> ¥${item._price}</p></div>
                <div class="fl le_width_172 e_quantity" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}"">
                    ${item._count}
                </div>
                <div class="fl le_width_172 e_sum" style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}""><p class="le_paddingl_65">¥${item.getTotalPrice()}</p></div>
            </div>`;
        });
        return html;
    }

    render(){
        let tmpId = this._model.__tempId + "_" + this._model._parent._id + '_' +this._model._parent._itemId;
        let html = "";
        html += `<div class="clearfix extra_item option ${this.getInvalidInfo().cls}" skuid='${tmpId}'>
            <div class="fl e_name extra_item_left">选件</div>
            <div class="fl extra_item_middle ${this.getInvalidInfo().cls}">${this.getItems()}</div>`;
            /*if(!this._model._parent._invalid) {
                html+=`<div class="fl le_width_116 extra_item_right">
                <div class="e_action"><p class="le_paddingl_26" tag="re_election" itemId='${tmpId}'>重选</p></div>
                </div>`;
            }*/
        $(this._parentEl).append($(html));
        
        this._el = $("div.option[skuid='"+tmpId+"']");
        this._ela = $(".option_wrapper");
        this.regEvent();
        
    }

    regEvent(){
        let that = this;
      
        //减少数量
        this._el.off("click","input[tag='optionreduce']").on("click","input[tag='optionreduce']",function(){
            let oid = $(this).attr("oid");
            let item = $array.filter(that._model._items, {_id:oid});
            if(item.length == 1){
                let count = parseInt(item[0]._count) - 1;
                that._model.modifyCount(count, oid).catch(err => { 
                    Alert.showTip(err);
                });;
            }
        })
  
        this._el.off("click","p[tag='re_election']").on("click","p[tag='re_election']",function(){
           
           let data =[]
           let arr = []
           let selectedP = that._el.find('.right_item')
           selectedP.each(function(index,li){
                arr .push($(li).attr('ids'))
            }); 
            // arr.push(that._el.find('.right_item').attr('ids'))
           let itemId = $(this).attr('itemId')
            that._model._parent.getOptionGoods().then((res)=>{
                data = that._model._parent._optionList._optionList
                // console.log(data,'that._model')
                $('.option_wrapper').show()
                $('.pc_mask').show()
                that._model._parent._optionList._view.render();
                $util.toggleBodyScroller(true);
                // $('.pc_mask').show()
                // $('.option_wrappers').show()
                // $(".option_wrappers h3").html(`<i class="fr close_receive iconfont icon-close" tag="onClickIconClose"></i>推荐选件`)
                // $(".optionsNone_text").html(`暂无选件`)

            }).catch(err => { 
                // Alert.showTip(err);
                $('.pc_mask').show();
                $util.toggleBodyScroller(true);
                $('.option_wrappers').show()
                $(".option_wrappers h3").html(`<i class="fr close_receive iconfont icon-close" tag="onClickIconClose"></i>选择选件`)
                $(".optionsNone_text").html(`暂无选件`)
            });
        
        })
        //增加数量
        this._el.off("click","input[tag='optionadd']").on("click","input[tag='optionadd']",function(){
            let oid = $(this).attr("oid");
            let item = $array.filter(that._model._items, {_id:oid});
            if(item.length == 1){
                let _count = item[0]._count;
                let count = parseInt(_count) + 1;
                that._model.modifyCount(count, oid).catch(err => { 
                    Alert.showTip(err);
                });;
            }
        })

        //blur变更数量
        this._el.off("blur","input[tag='optionCount']").on("blur","input[tag='optionCount']",function(){

            let oid = $(this).attr("oid");
            let item = $array.filter(that._model._items, {_id:oid});

            if(item.length == 1){
                let addEl = $(this).parent().find("input[tag=optionadd]");
                let reduceEl = $(this).parent().find("input[tag=optionreduce]");
                ViewTool.blurModifyCount(this, addEl, reduceEl, that._model, item[0]._count, {
                    oid:oid,
                    item:item
                });
            }
            
            // if(item.length == 1){
            //     let _count = item[0]._count;
            //     let count = parseInt(_count) + 1;
            //     that._model.modifyCount(count, oid).catch(err => { 
            //         Alert.showTip(err);
            //     });;
            // }
        })
        $('.option_wrappers').off("click","[tag='onClickIconClose']").on("click","[tag='onClickIconClose']",function(){
            $('.option_wrappers').hide();
            $('.pc_mask').hide();
            $util.toggleBodyScroller(false);
            
        })
    }
}